import React from "react";
import { ResetPasswordModel } from "src/model/ResetPasswordModel";
import { AuthService } from "src/model/AuthService";

export const ResetPasswordContext = React.createContext(new ResetPasswordModel(new AuthService()));
